export default {
    baseUrl: 'https://aina.nexaid.app'
    // baseUrl: 'http://localhost:5400'
}